import { ArrowRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

function CTASection() {
  return (
    <section className="w-full h-auto overflow-hidden relative flex flex-col lg:p-16 p-8 bg-background">
      <div className="bg-gradient-to-br from-primary via-primary/95 to-primary/80 rounded-3xl relative overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-500 group">
        <div className="absolute -right-44 top-1/2 size-[800px] group-hover:-translate-y-1/2 rounded-full bg-gradient-to-r from-white via-white/30 to-white/30 shadow-xl transition-transform duration-700 ease-out delay-0"></div>
        <div className="absolute -right-40 bottom-1/2 size-[700px] group-hover:translate-y-1/2 rounded-full bg-gradient-to-r from-white via-white/30 to-white/30 shadow-xl transition-transform duration-700 ease-out delay-[50ms]"></div>
        <div className="absolute -right-36 top-1/2 size-[600px] group-hover:-translate-y-1/2 rounded-full bg-gradient-to-r from-white via-white/30 to-white/30 shadow-lg transition-transform duration-700 ease-out delay-75"></div>
        <div className="absolute -right-32 bottom-1/2 size-[500px] group-hover:translate-y-1/2 rounded-full bg-gradient-to-r from-white via-white/30 to-white/30 shadow-lg transition-transform duration-700 ease-out delay-150"></div>
        <div className="absolute -right-28 top-1/2 size-[400px] group-hover:-translate-y-1/2 rounded-full bg-gradient-to-r from-white via-white/30 to-white/30 shadow-md transition-transform duration-700 ease-out delay-200"></div>
        <div className="absolute -right-24 bottom-1/2 size-[300px] group-hover:translate-y-1/2 rounded-full bg-gradient-to-r from-white via-white/30 to-white/30 shadow-md transition-transform duration-700 ease-out delay-300"></div>

        <div className="absolute bg-gradient-to-t from-black/70 via-black/40 to-transparent flex lg:hidden w-full h-full" />

        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white/60 rounded-full animate-pulse"></div>
          <div className="absolute top-3/4 left-1/3 w-1 h-1 bg-white/40 rounded-full animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/5 w-1.5 h-1.5 bg-white/50 rounded-full animate-pulse delay-500"></div>
        </div>

        <div className="container relative z-10 mx-auto px-8 py-16 md:py-24">
          <div className="max-w-2xl transform transition-transform duration-500 ease-out">
            <h2 className="mb-6 text-xl md:text-5xl font-bold text-white drop-shadow-lg leading-tight tracking-tight">
              {"Let's Talk Over a Cup of Coffee."}
            </h2>
            <p className="mb-10 text-sm md:text-xl text-white/95 leading-relaxed drop-shadow-md font-medium">
              Ready to discuss your business goals, digital strategy, or
              software needs? Connect with our expert tech team and discover how
              we can help you innovate, grow, and stay ahead in today's digital
              world.
            </p>
            <Link
              to="/contact-us"
              className="inline-flex items-center gap-2 px-4 py-2 md:px-8 md:py-4 bg-white hover:bg-white/95 active:bg-white/90 transition-all duration-300 rounded-full text-primary font-bold md:text-lg shadow-xl hover:shadow-2xl hover:scale-105 active:scale-95 transform group/button"
            >
              <span>Contact Us</span>
              <ArrowRight className="w-5 h-5 group-hover/button:translate-x-1 transition-transform duration-300" />
            </Link>
          </div>
        </div>

        {/* <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-primary/20 to-transparent pointer-events-none"></div> */}
      </div>
    </section>
  );
}

export default CTASection;
